const PurchasePurchasesHistoryList = () => {
    return <div>Package Purchase History Add</div>;
}

export default PurchasePurchasesHistoryList;